import {
  PRIVATE_HTTP as http,
  PRIVATE_HTTP_BFF as http_bff,
} from '../http-common';

const policy = async (id: number) => {
  return http().get(`/api/v4/policies/${id}`);
};

const policyVt7Payment = async (params: any) => {
  return http_bff().get(`temp/debt/vt7`, { params });
};

const cancelPolicyRequest = async (body: object, policyId: number) => {
  return http().post(`/api/v4/policies/${policyId}/unsubscribe`, body);
};

const cancellationReasons = async () => {
  return http().get(`/api/v4/policies/cancel_reasons`);
};

const sumAssured = async (policyId: number, vehicle_id: number) => {
  return http().post(`/api/v4/policies/${policyId}/endorsements/sum_insured`, {
    vehicle_id,
  });
};

const sumInsuredQuotation = async (
  policyId: number,
  job_number: number,
  vehicle_id: number,
  stated_amount: number
) => {
  return http().post(
    `/api/v4/policies/${policyId}/endorsements/sum_insured_quote`,
    { job_number, vehicle_id, stated_amount }
  );
};

const getAdjustClause = async (policyId: number, vehicle_id: number) => {
  return http().post(
    `/api/v4/policies/${policyId}/endorsements/adjustment_clause`,
    { vehicle_id }
  );
};

const adjustClauseQuotation = async (
  policyId: number,
  job_number: number,
  vehicle_id: number,
  clause_value: number
) => {
  return http().post(
    `/api/v4/policies/${policyId}/endorsements/adjustment_clause_quote`,
    { job_number, vehicle_id, clause_value }
  );
};

const finishEndorsement = async (policyId: number, job_number: number) => {
  return http().post(
    `/api/v4/policies/${policyId}/endorsements/finish_endorsement`,
    { job_number }
  );
};

const securedClausePercentage = async () => {
  return http().get(`/api/v4/policies/percentages`);
};

const policies = async (params?: any[], pageParam?: Number) => {
  return http().get(
    `/api/v4/policies?${
      params && params.length
        ? `${params
            .map(
              (param) =>
                `&page_number=${pageParam}&${param.name}=${param.value}`
            )
            .join('&')}`
        : `&page_number=${pageParam}`
    }`
  );
};

const printDocument = async (
  id: any,
  doc_type: any,
  //endorsement_id?: any,
  alternative_email?: any
) => {
  return http().get(
    `/api/v4/policies/${id}/endorsements/printable_document?doc_type=${doc_type}` +
      (alternative_email ? `&alternative_email=${alternative_email}` : '')
  );
};

const downloadPolicy = async (id: any) => {
  const response = http().get(
    `/api/v4/policies/${id}/endorsements/printable_document`
  );
  // const response = http().get(`/api/v4/policies/22333/endorsements/printable_document`);
  return response;
};

const autoSynchronizationPolicies = async () => {
  const response = await http().put(`/api/v4/users/resync`);
  // console.log('autoSynchronizationPolicies', response);
  return response?.status === 202 ? true : false; // true == done
};

const createEndorsementAPI = async (policy_id: number, data: any) => {
  return http().post(`/api/v4/policies/${policy_id}/endorsements/`, data);
};

const policyRequest = async () => {
  return http().get(`/api/v4/policies/requests`);
};

const getAccesories = async (vehicle_id: number) => {
  return http().get(
    `/api/v4/users/vehicles/${vehicle_id}/extended_coverage?include_accessories=true`
  );
};

const getExtension = async (policy_id: number) => {
  return http().get(`/api/v4/policies/${policy_id}/extension`);
};

export {
  policy,
  policies,
  printDocument,
  createEndorsementAPI,
  policyRequest,
  cancelPolicyRequest,
  cancellationReasons,
  getAccesories,
  securedClausePercentage,
  sumAssured,
  sumInsuredQuotation,
  getAdjustClause,
  adjustClauseQuotation,
  finishEndorsement,
  getExtension,
  downloadPolicy,
  autoSynchronizationPolicies,
  policyVt7Payment,
};
